import { getThemeOfGameBox } from "./theme";

export const changeTheme = (themeParam: string) => {
    const switcherValue = sessionStorage.getItem('switcherValue') as string || themeParam;
    const themeValue =  getThemeOfGameBox(switcherValue);
    try {
        const root = document.querySelector(':root') as HTMLElement;
        if (root) {
            for (const variable in themeValue) {
                if (Object.prototype.hasOwnProperty.call(themeValue, variable)) {
                    root.style.setProperty(variable, themeValue[variable]);
                }
            }
        }
    } catch (e) {
        console.error('Failed to parse theme parameter:', e);
    }
}